/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OTPAttestationData } from './OTPAttestationData';
import {
    OTPAttestationDataFromJSON,
    OTPAttestationDataFromJSONTyped,
    OTPAttestationDataToJSON,
} from './OTPAttestationData';

/**
 * 
 * @export
 * @interface OTPAttestationAllOf
 */
export interface OTPAttestationAllOf {
    /**
     * 
     * @type {OTPAttestationData}
     * @memberof OTPAttestationAllOf
     */
    data?: OTPAttestationData;
}

/**
 * Check if a given object implements the OTPAttestationAllOf interface.
 */
export function instanceOfOTPAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OTPAttestationAllOfFromJSON(json: any): OTPAttestationAllOf {
    return OTPAttestationAllOfFromJSONTyped(json, false);
}

export function OTPAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : OTPAttestationDataFromJSON(json['data']),
    };
}

export function OTPAttestationAllOfToJSON(value?: OTPAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': OTPAttestationDataToJSON(value.data),
    };
}

